import { createSlice } from '@reduxjs/toolkit';
import PlaceholderCar from 'assets/images/placeholder-car.png';

const initialState = {
  leasingData: {},
  eicsData: {},
  specificationsData: [],
  rawSpecificationsData: {},
  builderData: {},
  bodyData: {},
  tireLabelsData: [],
  compatibilityData: {},
  locationsData: [],
  consentsData: [],
  modelsData: [],
  errorData: {}
};

const slice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setLeasingData: (state, { payload }) => {
      state.leasingData = payload.reduce((res, input) => {
        const { eic, ...rest } = input;
        res[eic] = {
          ...rest,
          period: [...(rest.period || [])].sort((a,b) =>
            a.value - b.value).map(item => (
              { ...item, mileage: [...item.mileage].sort((a,b) => a.price - b.price) }
            ))
        };
        return res;
      }, {});
    },
    setEicsData: (state, { payload }) => {
      state.eicsData = payload.reduce((res, input) => {
        res[input.grade.id] = res[input.grade.id] || [];
        res[input.grade.id].push(input);
        return res;
      }, {});
    },
    setSpecificationsData: (state, { payload }) => {
      state.specificationsData = payload.reduce((res, input) => {
        res[input.grade.id] = res[input.grade.id] || [];
        res[input.grade.id].push(input);
        return res;
      }, {});
    },
    setRawSpecificationsData: (state, { payload }) => {
      state.rawSpecificationsData = payload;
    },
    setBuilderData: (state, { payload }) => {
      const { accessories = [], techdata = [] } = payload;
      let newPayload = { ...payload };
      newPayload.accessories = accessories.reduce((obj, el) => {
        obj[el.categoryName] = [...(obj[el.categoryName] || []), el];
        return obj;
      }, {});
      newPayload.techdata = techdata.reduce((obj, el) => {
        obj[el.categoryName] = [...(obj[el.categoryName] || []), el];
        return obj;
      }, {});
      newPayload.leasing = state.leasingData[newPayload.eic];
      //const defaultWheels = wheels.find(item => !item.code);
      //newPayload.wheels = [defaultWheels, ...wheels.filter(item => !!item.code)];
      state.builderData = newPayload;
    },
    setBodyData: (state, { payload }) => ({...initialState,
      eicsData: state.eicsData,
      specificationsData: state.specificationsData,
      bodyData: [...payload].sort((a, b) => // sort asc by price
        a.price - b.price
      ).reduce((mapped, item) => { // group engines by body
        mapped[item.body.id] = mapped[item.body.id] || {...item.body, engines: []};
        if (!mapped[item.body.id].engines.some(engine => engine.eic === item.eic)) { // check duplicates by eic value
          mapped[item.body.id].engines.push({
            ...item.engine,
            eic: item.eic,
            title: item.name,
            price: item.price,
            leasing: item.leasing,
            img: item.exterior?.pictures?.main || PlaceholderCar
          });
        }
        return mapped;
      }, {})
    }),
    setTireLabelsData: (state, { payload }) => {
      state.tireLabelsData = payload;
    },
    setCompatibilityData: (state, { payload }) => {
      state.compatibilityData = payload;
    },
    setLocationsData: (state, { payload }) => {
      state.locationsData = payload;
    },
    setConsentsData: (state, { payload }) => {
      state.consentsData = payload.filter(item =>
        [
          'configurator consent email',
          'configurator consent phone',
          'configurator consent sms'
        ].some(el =>
          item.title.toLowerCase().includes(el)
        )
      );
    },
    setModelsData: (state, { payload }) => {
      state.modelsData = payload;
    },
    setErrorData: (state, { payload }) => {
      state.errorData = payload;
    },
    resetBuilderData: state => initialState,
  },
});

export const {
  setLeasingData,
  setEicsData,
  setSpecificationsData,
  setRawSpecificationsData,
  setBuilderData,
  setBodyData,
  setTireLabelsData,
  setCompatibilityData,
  setLocationsData,
  setConsentsData,
  setModelsData,
  setErrorData,
  resetBuilderData
} = slice.actions;

export default slice.reducer;
